

const NewsList2023 = [

    {
        dt: "December",
        my: "",
        link: "",
        title: "Congratulations to Mr. Mohammad Irfan",
        desc: "Mr. Mohammad Irfan, received “Best Oral presentation Award” from International Conference on Separation and Purification Technologies (ICSPT-2023) held on Dec 7th – 8th , 2023, at IIT Patna."
    },

    {
        dt: "July",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/events/2023/5GAward_IITTP.png",
        title: "Congratulations to Mr. Yumnum Nandan",
        desc: "Mr. Yumnum Nandan, CH Research scholar (Supervisor: Prof. KSMS Raghavarao & Dr. Nilesh Choudhary) received the prestigious Prime Minister's Fellowship for Doctoral Research"
    },

    {
        dt: "October",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/events/2023/5GAward_IITTP.png",
        title: "5G Awards",
        desc: "Award of 5G lab to IIT TIRUPATI"
    },
    {
        dt: "July",
        my: "",
        link: "",
        title: "Congratulations to Mr. Yumnum Nandan",
        desc: "Mr. Yumnum Nandan,  CH Research scholar (Supervisor: Prof. KSMS Raghavarao   Dr. Nilesh Choudhary) received the prestigious 'Prime Minister's Fellowship for Doctoral Research'."
    },
    {
        dt: "July",
        my: "",
        link: "",
        title: "Congratulations to Ms. N Sai Prasanna",
        desc: "Ms. N Sai Prasanna, CH Research scholar (Supervisor: Prof. KSMS Raghavarao   Dr. Nilesh Choudhary) received the prestigious 'Prime Minister's Fellowship for Doctoral Research'."
    },
    {
        dt: "21 - 22",
        my: "July",
        link: "",
        title: "Congratulations to Mr. Allabakshi S. M, Civil Engineering Research scholar received “Best Poster Award”",
        desc: "Mr. Allabakshi S. M (CEE, Ph.D. scholar) received “Best Poster Award” from Center of Excellence at Conference On Desalination, Brine Management And Water Recycling held on July 21st – 22nd, 2023, at IIT Bombay. "
    },
    {
        dt: "19 - 23",
        my: "June",
        link: "",
        title: "Congratulations to Prof KSMS Raghava Rao has been awarded the prestigious Life Time Achievement Award by International Association of Engineering and Food.",
        desc: "Prof KSMS Raghava Rao has been awarded the prestigious Life Time Achievement Award by International Association of Engineering and Food. He will receive the award at ICEF14 to be held at Nantes, France in June 2023."
    },
    {
        dt: "6 - 7",
        my: "March",
        link: "",
        title: "Congratulations to Mr. Allabakshi S. M, Civil Engineering Research scholar received the first prize in Best oral presentation award category",
        desc: "Mr. Allabakshi S. M (CEE, Ph.D. scholar) received the first prize in Best oral presentation award category from the 1st Institute Level Research Scholars Symposium organized by IIT Tirupati, India held on May 9th, 2023, at IIT Tirupati"
    },
    {
        dt: "17",
        my: "March",
        link: "",
        title: "Congratulations to Mr. V. Sunil (MS Scholar under guidance of Dr. Uday Kumar Sukumar & Dr. K. Anki Reddy, Department of Chemical Engineering) got selected for Khorana Program of Internships - 2023",
        desc: "Mr. V. Sunil (MS Scholar under guidance of Dr. Uday Kumar Sukumar & Dr. K. Anki Reddy, Department of Chemical Engineering) got selected for Khorana Program of Internships - 2023 to be pursued at Purdue University, USA "
    },
    {
        dt: "24",
        my: "March",
        link: "",
        title: "Congratulations to Mr. Vikrant Yadav and Mr. Sonu Jana",
        desc: "Mr. Vikrant Yadav and Mr. Sonu Jana (Department of Physics, Ph.D. scholars) have been awarded the prestigious MITACS GLOBALINK RESEARCH for a 3 month internship program at Professor Amar Vutha’s research group at the University of Toronto, Canada. Incidentally Sonu Jana is funded by the IITT TIH Chanakya Doctoral Fellowship. Both of them are involved in portable atomic clock development at IIT TIRUPATI. "
    },
    {
        dt: "6 - 7",
        my: "March",
        link: "",
        title: "Congratulations to Mr. Allabakshi S. M, Civil Engineering Research scholar received the first prize in Best Paper Award Category.",
        desc: "Mr. Allabakshi S. M (CEE, Ph.D. scholar) received the first prize in 'Best Paper Award Category' from the Indo-Canadian Symposium on Water Management: Sustainability & Impact of Climate Change organized by Dalhousie University, Canada and IIT Tirupati, India held on March 6th – 7th, 2023, at IIT Tirupati. "
    },
    {
        dt: "12 - 14",
        my: "February",
        link: "",
        title: "Congratulations to Ms. Vajitha. G, Civil Engineering Research scholar received the 'Best poster presentation award'",
        desc: "Ms. Vajitha. G (CEE, Ph.D. scholar) received the Best poster presentation award at the 35th Kerala Science Congress held at Mar Baselios Christian College of Engineering and Technology on 12th – 14th, February 2023, Kerala."
    }
];


export default NewsList2023;